export default {
    ADD: "Добавить",
    CANCEL: "Отменить",
    CHOOSE_USER: "Выберите пользователя",
    USER: "Пользователь",
    CHOOSE_ACCESS: "Выберите роль",
    ACCESS: "Роль"
};
